import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'
import { masker, mapToNumeric } from '@convenia/common-organisms/SystemFields/helpers/formatters'
import { camelToSnakeKeys } from '@convenia/helpers'

import { mapFiles } from './upload'
import { ADDRESSES_CONTACTS_AREA } from '../consts'

export const mapAddress = (data = {}, params) => ({
  ...(data || {}),
  zipCode: masker('#####-###', data?.zipCode || ''),
  cityId: Number(data?.city?.id) || null,
  stateId: Number(data?.state?.id) || null,
  files: mapFiles(data?.documentFiles || [], params) || [],
})

export const mapAddressInput = ({ schema, data } = {}) => ({
  ...camelToSnakeKeys({
    zipCode: (data?.zipCode || '').replace(/\D+/, ''),
    address: data?.address || '',
    number: data?.number,
    complement: data?.complement || '',
    district: data?.district || '',
    cityId: data?.cityId || null,
    stateId: data?.stateId || null,
  }),
  custom_fields: mapCustomFieldValues({
    sectionId: ADDRESSES_CONTACTS_AREA.ADDRESS,
    entityId: data?.entityId || undefined,
    data,
    schema
  })
})

export const mapContacts = (data) => ({
  ...(data || {}),
  cellphone: masker('(##) #####-####', data?.personalCellphone),
  telephone: masker('(##) ####-####', data?.residentialPhone),
  email: data?.personalEmail || '',
})

export const mapContactInput = ({ schema, data } = {}) => ({
  ...camelToSnakeKeys({
    residentialPhone: mapToNumeric(data?.telephone),
    personalCellphone: mapToNumeric(data?.cellphone),
    personalEmail: data?.email || '',
  }),
  custom_fields: mapCustomFieldValues({
    sectionId: ADDRESSES_CONTACTS_AREA.CONTACTS,
    data,
    schema
  })
})

export const mapEmergencyContact = (data) => ({
  ...(data || {}),
  emergencyContactRelationId: data?.emergencyContactRelation?.id,
  relation: data?.emergencyContactRelation?.id,
  telephone: masker('(##) ####-####', data?.phone),
  cellphone: masker('(##) #####-####', data?.cellphone),
  workPhone: masker('(##) ####-####', data?.workPhone),
})

export const mapEmergencyContactInput = ({ entityId, schema, data } = {}) => ({
  ...camelToSnakeKeys({
    emergencyContactRelationId: data?.emergencyContactRelationId,
    phone: mapToNumeric(data?.telephone),
    cellphone: mapToNumeric(data?.cellphone),
    workPhone: mapToNumeric(data?.workPhone),
    email: data?.email || '',
    name: data?.name || '',
  }),
  custom_fields: mapCustomFieldValues({
    sectionId: ADDRESSES_CONTACTS_AREA.EMERGENCY_CONTACTS,
    entityId: entityId || data?.entityId,
    data,
    schema
  })
})
